import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    sales: [],
    expenses: [],
    income: [],
  },
  loading: false,
  error: null,
};

const pnlReportSlice = createSlice({
  name: "PnlBasic",
  initialState,
  reducers: {
    BasicPnLDataRequest(state) {
      state.loading = true;
      state.error = null;
    },
    BasicPnLDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { sales, buys, expenses, income }
    },
    BasicPnLDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  BasicPnLDataRequest,
  BasicPnLDataSuccess,
  BasicPnLDataFailure,
} = pnlReportSlice.actions;

export default pnlReportSlice.reducer;